<template>
    <div style="padding-top: 1em;">
        <div class="column is-8">
            <div class="box">
                <article class="media">
                    <div class="media-content">
                        <div class="content">
                            <p></p>
                            <p class="is-size-4">Changes to Ward Boundaries</p>

                            <strong
                                >As a result of a mandatory review of Council’s
                                composition which was completed in 2017 some
                                changes to ward boundaries came into effect
                                for the 2018 Election.</strong
                            >

                            <ul
                                style="list-style: initial; padding: 1em; margin-left: 2em;"
                            >
                                <li>
                                    The entire suburb of Glanville is now located within the Port Adelaide Ward.
                                </li>
                                <li>
                                    The entire suburb of Birkenhead is now located in the Semaphore Ward.
                                </li>
                                <li>
                                    The entire suburb of Ottoway is now located in the Parks Ward.
                                </li>
                            </ul>

                        </div>
                    </div>
                </article>
            </div>
        </div>

        <h4 class="title" style="margin-top: 1em;">Search</h4>

        <div class="columns is-multiline">
            <!-- Enter Address Selector Here -->
            <div class="column is-8">
                <div class="field">
                    <label class="label"
                        >Find out what Council Ward you are in by typing your
                        address...</label
                    >
                    <div class="control">
                        <PropertyAddress
                            fieldName="address"
                            source="/api/address/search"
                            placeholder="eg. 1/10 Main St Semaphore"
                            v-on:addressWard="saveWard"
                            v-on:address="saveStreetAddress"
                        ></PropertyAddress>
                    </div>
                </div>
            </div>

            <div v-if="addressWard != 'none'" class="column is-8">
                <div class="field">
                    <span class="title">{{ addressWard }} Ward</span>
                    <br />
                    <a
                        v-if="addressWard == 'ENFIELD'"
                        href="https://cityofpae.sa.gov.au/?a=413193"
                        target="_blank"
                        >Detailed Ward Map</a
                    >

                    <a
                        v-if="addressWard == 'KLEMZIG'"
                        href="https://cityofpae.sa.gov.au/?a=414209"
                        target="_blank"
                        >Detailed Ward Map</a
                    >

                    <a
                        v-if="addressWard == 'NORTHFIELD'"
                        href="https://cityofpae.sa.gov.au/?a=413820"
                        target="_blank"
                        >Detailed Ward Map</a
                    >

                    <a
                        v-if="addressWard == 'OUTER HARBOR'"
                        href="https://cityofpae.sa.gov.au/?a=411288"
                        target="_blank"
                        >Detailed Ward Map</a
                    >

                    <a
                        v-if="addressWard == 'PARKS'"
                        href="https://cityofpae.sa.gov.au/?a=410706"
                        target="_blank"
                        >Detailed Ward Map</a
                    >

                    <a
                        v-if="addressWard == 'PORT ADELAIDE'"
                        href="https://cityofpae.sa.gov.au/?a=412084"
                        target="_blank"
                        >Detailed Ward Map</a
                    >

                    <a
                        v-if="addressWard == 'SEMAPHORE'"
                        href="https://cityofpae.sa.gov.au/?a=412445"
                        target="_blank"
                        >Detailed Ward Map</a
                    >

                    <!-- <a
            :href="'http://www.cityofpae.sa.gov.au/sitedata/unity/resources/files/Map_' + addressWard.replace(/\s/g,'') + 'Ward.pdf'"
            target="_blank"
          >Detailed Ward Map</a> -->
                    <!-- ELECTED MEMBERS LINK
               	<a :href="'http://www.portenf.sa.gov.au/electedmembers#' + removeSpaces( titleCase(addressWard) )" target="_blank">Elected Members</a>
          -->
                </div>
            </div>

            <div class="column is-8" v-if="enableGoogleCaptch">
                <div class="field">
                    <vue-recaptcha
                        ref="invisibleRecaptcha"
                        @verify="onVerify"
                        @expired="onExpired"
                        size="invisible"
                        :sitekey="googleCaptchaKey"
                    ></vue-recaptcha>
                </div>
            </div>
        </div>

        <div id="map"></div>
    </div>
</template>
<script>
import * as d3 from "d3";
import * as topojson from "topojson-client";

import VueRecaptcha from "vue-recaptcha";
import PropertyAddress from "../address/Typeahead-CouncilAddress.vue";

export default {
    components: {
        PropertyAddress,
        VueRecaptcha
    },

    data() {
        return {
            googleCaptchaKey: "6LcyrE0UAAAAAExxoj3NBm1vA-WMu88CIigyzkBU",
            enableGoogleCaptch: false,

            address: "",
            addressWard: "none",
            svg: null,
            path: null,
            projection: null,
            width: 800,
            height: 450,
            scale: 190000,
            lat: "43.2",
            point: [0, 0],
            projected: []
        };
    },
    mounted: function() {
        this.createMap();
    },

    watch: {
        point: function() {
            this.calculateProjection();
        },
        address: function() {
            this.getCoordinates(this.address.replace(/\//g, "-"));
        }
    },

    methods: {
        getCoordinates(address) {
            axios.post("/api/coordinates/" + address).then(response => {
                console.log(
                    this.address +
                        "  " +
                        response.data.lat +
                        ":" +
                        response.data.lng
                );
                this.point = [response.data.lng, response.data.lat];
            });
        },

        saveStreetAddress(value) {
            this.address = value;
        },
        saveWard(value) {
            this.addressWard = value.toUpperCase();
        },
        onVerify: function(response) {
            this.loading = true;
            if (response) {
                axios
                    .post("/api/recaptchaSiteVerify", {
                        value: response
                    })
                    .then(gresponse => {
                        //console.log(gresponse)
                        if (gresponse["data"] === "valid") {
                            // axios.post('/onlineform/'+this.form, {
                            //   _token: this.csrf,
                            //   formTitle: this.formTitle,
                            //   fullName: this.fullName,
                            //   emailAddress: this.emailaddress,
                            //   contactNumber: this.contactnumber,
                            //   precis: this.precis,
                            //   formData: this.formData,
                            //   message: ''
                            // })
                            // .then((response) => {
                            //   //console.log(response.data.message)
                            //   this.message = response.data.message
                            //   this.clear()
                            //   this.submitted = true
                            // });
                        } else {
                            console.log("Failed verify google captcha!");
                        }
                    })
                    .catch(error => {
                        console.log(error.response.data);
                    });
            } else {
                alert("Failed captcha");
            }
        },
        onExpired: function() {
            console.log("Expired");
        },

        createMap() {
            this.svg = d3
                .select("#map")
                .append("svg")
                .attr("width", this.width)
                .attr("height", this.height);

            this.projection = d3
                .geoAlbers()
                .center([-1.386, -34.83])
                //.center([-1.384, -34.88])
                .scale(this.scale)
                .rotate([220, 0])
                .parallels([-33.4, -33.5])
                //.parallels([-33.4, -33.6])
                .translate([this.width / 2, this.height / 2]);

            this.path = d3.geoPath().projection(this.projection);

            this.request();
        },
        request() {
            //console.log('request')
            let self = this;
            d3.json("/maps/pae/wards_topo.json").then(function(data) {
                //d3.json('/maps/pae/salward_topo.json').then(function(data) {

                self.svg
                    .selectAll(".subunit")
                    .data(topojson.feature(data, data.objects.Wards).features)
                    //.data(topojson.feature(data, data.objects.Ward).features)
                    .enter()
                    .append("path")
                    .attr("class", function(d) {
                        return (
                            "subunit land " +
                            d.properties.WARD_NAME.toUpperCase().replace(
                                /\s/g,
                                ""
                            )
                        );
                    })
                    //.attr("class", function(d) { return "subunit land " + d.properties.WARD_NAME.toUpperCase().replace(/\s/g,'') })
                    .attr("d", self.path);

                // add circles to svg
                self.svg
                    .selectAll("circle")
                    .data([self.point])
                    .enter()
                    .append("circle")
                    .attr("cx", function(d) {
                        return self.projected[0];
                    })
                    .attr("cy", function(d) {
                        return self.projected[1];
                    })
                    .attr("r", "5")
                    .attr("fill", "red");
            });
            this.calculateProjection();
        },
        calculateProjection() {
            this.projected = this.projection(this.point);

            this.svg
                .select("circle")
                .attr("cx", this.projected[0])
                .attr("cy", this.projected[1])
                .attr("r", "5")
                .attr("fill", "#333333");

            this.svg.selectAll(".land").classed("active", false);

            this.svg
                .select("." + this.addressWard.toUpperCase().replace(/\s/g, ""))
                .classed("active", true);
        }
    }
};
</script>
<style>
.stroke {
    fill: none;
    stroke: #000;
    stroke-width: 3px;
}

.fill {
    fill: #fff;
}

.graticule {
    fill: none;
    stroke: #777;
    stroke-width: 0.5px;
    stroke-opacity: 0.5;
}

.land {
    fill: #ccdadd;
    stroke: #fff;
    stroke-width: 0.5px;
}

.boundary {
    fill: none;
    stroke: #fff;
    stroke-width: 0.5px;
}

.active {
    fill: #17c4ee;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/our-council/Wards.vue